import React, { useEffect, useState } from "react";
import API from "../api";
import { Form, Button, Alert } from "react-bootstrap";

const AdminResetPassword = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await API.get("/admin/users");
        setUsers(res.data);
      } catch (err) {
        setMessage("Failed to load users.");
      }
    };
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("/admin/reset-user-password", {
        user_id: selectedUser,
        new_password: newPassword,
      });
      setMessage("Password updated successfully.");
    } catch (err) {
      setMessage("Failed to reset password.");
    }
  };

  return (
    <div className="container mt-4">
      <h2>Admin: Reset User Password</h2>
      {message && <Alert variant="info">{message}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Select User</Form.Label>
          <Form.Select
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            required
          >
            <option value="">-- Select User --</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.email}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>New Password</Form.Label>
          <Form.Control
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit">Reset Password</Button>
      </Form>
    </div>
  );
};

export default AdminResetPassword;
